import { render } from "./ExportHistoryTable.vue?vue&type=template&id=740e52d1&scoped=true"
import script from "./ExportHistoryTable.vue?vue&type=script&lang=js"
export * from "./ExportHistoryTable.vue?vue&type=script&lang=js"

import "./ExportHistoryTable.vue?vue&type=style&index=0&id=740e52d1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740e52d1"]])

export default __exports__